// extracted by mini-css-extract-plugin
export default {"button":"button_button__X9kjH","black":"button_black__2Eqa9","email":"button_email__0wkeQ"};